import routeAuth from '~/libs/route-authentication'
import { useRootStore } from '~/store/root'

export default defineNuxtRouteMiddleware(async (to) => {
  const nuxtApp = useNuxtApp()
  const { $pinia, $lendioCookies } = nuxtApp
  const rootStore = useRootStore($pinia)
  const authUser = rootStore.authUser
  const _isEmbedded = rootStore.isEmbedded
  const isTest = authUser && authUser.email?.includes('@lendio.com') && authUser.email?.includes('lendiotest')

  if (routeAuth.isTestOnlyRoute(to) && !(isTest || $lendioCookies.get('allowTestRoutes') == true)) {
    if (_isEmbedded) {
      throw createError({
        statusCode: 401,
        statusMessage: 'Unauthorized Action',
        data: {
          isEmbedded: true,
          location: 'Authenticate - Test Only'
        },
        fatal: true
      })
    }

    if (authUser) {
      throw createError({
        statusCode: 404,
        message: `Not found: ${to.path}`,
        fatal: true
      })
    }
  }
})
